import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useMemo } from '@redneckz/uni-jsx/lib/hooks';
import { useBranchesByRegions } from '../../hooks/useBranchesByRegions.js';
import { SelectControl } from '../../ui-kit/Select/SelectControl.js';
import { validatorObj } from './getObjectValidator.js';
import { getValidation } from './getValidation.js';
export const RegionPremiumField = JSX(({ field, input }) => {
    const branchByRegions = useBranchesByRegions();
    const regions = useMemo(() => branchByRegions?.map(({ region }) => ({
        key: region,
        text: region,
    })), [branchByRegions]);
    return (_jsx(SelectControl, { label: "\u0420\u0435\u0433\u0438\u043E\u043D", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0435\u0433\u0438\u043E\u043D", options: regions, ...getValidation(field('region'), validatorObj.region, input?.required) }));
});
//# sourceMappingURL=RegionPremiumField.js.map